export default __webpack_public_path__ + "static/media/CI.dc4cd7a9.svg";